export default function LinkTargetBlankPlugin() {
  document.querySelectorAll('.editor-link').forEach(function (elem) {
    elem.setAttribute('target', '_blank');
  });
  return null;
}
